module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggZD0iTTMgMjJ2LTIwbDE4IDEwLTE4IDEweiIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/seestadtbot/play.svg
// module id = 353
// module chunks = 8